import { Search } from "components/Search/Search";
import { SwitchBtn } from "components/SwitchBtn/SwitchBtn";
import { trans } from "utils/helpers";

interface ItemCardsHeaderProps {
    handleModeCard : (e:boolean)=>void,
  
    data?:any,
    handleSearch?:any

}
export const ItemCardsHeader = ({handleModeCard,handleSearch,data}:ItemCardsHeaderProps) => {
    return ( 
        <nav className="d-md-flex me-auto  justify-content-end ms-3 ">
            <div style={{maxWidth:'25%',minWidth:'fit-content' }} className="me-4">
                <SwitchBtn firstMode="ascard" secondMode={'AsList'} setColor="customerColor" setShape="circle"  handleModeCard={handleModeCard}/>
            </div>
        </nav>
     );
}